import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
    Box, Typography, Button, IconButton, CircularProgress,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Select, MenuItem, FormControl, InputLabel, Pagination,
    TextField,
    InputAdornment,
    Grid,
    Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Plus, SearchIcon } from 'lucide-react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Context from '../../context/Context';
import { toast } from 'react-toastify';
import { getAllServices } from '../../Apis/ServicesApis';
// import { debounce, throttle } from 'lodash';
import DeleteConfirm from '../../Common/DeleteConfirm';
import { useDebounce } from "../../hooks/useDebounce";
import apiClient from '../../utils/apiClient';

const DisplayService = () => {
    const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
        confirmDelete } = useContext(Context);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [errors, setErrors] = useState('')
    const [searchTerm, setSearchTerm] = useState('');
    const [services, setServices] = useState([])
    const [status, setStatus] = useState("")

    const debouncedSearch = useDebounce(searchTerm, 500);

    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        setLoading(true)
        try {
            const response = await apiClient.delete(`/services/deleteservices/${itemIdToDelete}`);
            if (response?.data?.status === true) {
                toast.success(response?.data?.message || "Service deleted successfully")
                handleSearch()
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || "Error deleting service")
        }
        finally {
            setLoading(false)
        }

    };
       const handleStatusChange = (e) => {
          setStatus(e.target.value);
          setPage(1);
          }; 

const handleSearch = async () => {
  try {
    setLoading(true);

    const payload = {
      search: debouncedSearch,
      page,
      pageSize: limit,
    };

   if (status !== "") {
    payload.isActive = JSON.parse(status);
}

    const data = await getAllServices(payload);

    if (data?.status === true) {
      setServices(data.services || []);
      setTotalItems(data.totalItems || 0);
      setTotalPages(data.totalPages || 1);
    } else {
      setErrors(data?.message);
    }
  } catch (error) {
    setErrors(error?.response?.data?.message || "Error fetching services");
  } finally {
    setLoading(false);
  }
};

    const handleEditClick = (service) => {

        navigate('/create-edit-service', {
            state: {
                isEditMode: true,
                service
            }
        });
    };
    const handleAddClick = () => {
        navigate('/create-edit-service', { state: { isEditMode: false, } });
    };
    const handleLimitChange = (e) => {
        setLimit(Number(e.target.value));
        setPage(1);
    };

    useEffect(() => {
  handleSearch();
}, [page, limit, debouncedSearch, status]);
    return (
        <>
        <Box sx={{ backgroundColor: "", height: "", padding: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h3">Services</Typography>
                <Button
                    variant="contained"
                    sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
                    onClick={handleAddClick}
                >
                    <Plus size={23} />
                    <Typography>Add Service</Typography>
                </Button>
            </Box>

            <Divider sx={{ marginBottom: 2 }} />

            {/* Rows per page selector */}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search services"
                        value={searchTerm}
                        // onChange={(e) => setSearchTerm(e.target.value)}
onChange={(e) => {
    setSearchTerm(e.target.value);
    setPage(1);
  }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon size={18} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ width: 300 }}
                    />

                    <FormControl fullWidth size='small'>
                        <InputLabel id="status-label">Status</InputLabel>
                        <Select
                            labelId="status-label"
                            id="status-select"
                            value={status}
                            label="Status"
                            onChange={handleStatusChange}
                        >
                             <MenuItem value="">All</MenuItem>
                            <MenuItem value="true">Active</MenuItem>
                            <MenuItem value="false">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, alignItems: 'center' }}>
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Rows per page</InputLabel>
                        <Select value={limit} label="Rows per page" onChange={handleLimitChange}>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                        </Select>
                    </FormControl>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSearch}
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
                    >
                        <SearchIcon size={14} />
                        <Typography>Search</Typography>
                    </Button> */}
                </Box>

            </Box>
            <Box>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} elevation={1}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Image</strong></TableCell>
                                    <TableCell><strong>Name</strong></TableCell>
                                    <TableCell><strong>Description</strong></TableCell>
                                    <TableCell><strong>Price</strong></TableCell>
                                    <TableCell><strong>Duration Minutes</strong></TableCell>
                                    <TableCell><strong>Is Active</strong></TableCell>
                                    <TableCell align='right'><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {services.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            No services found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    services.map((service) => (
                                        <TableRow key={service.id}>
                                            <TableCell>
                                                <img
                                                    src={service.imageUrl}
                                                    alt={service?.name}
                                                    style={{ width: 70, height: 70, borderRadius: 5 }}
                                                />
                                            </TableCell>
                                            <TableCell>{service?.name}</TableCell>
                                            <TableCell>
                                                {service?.description?.length > 50
                                                    ? service.description.slice(0, 50) + '...'
                                                    : service.description}
                                            </TableCell>
                                            <TableCell>{service.price}</TableCell>
                                            <TableCell>{service.durationMinutes}</TableCell>
                                            <TableCell>{service?.isActive === true ? "true" : "false"}</TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                    <IconButton onClick={() => handleEditClick(service)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton color="error" onClick={() => confirmDelete(service.id)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
                {errors && (
                    <Typography color="error" variant="body2" sx={{ textAlign: 'center' }}>
                        {errors}
                    </Typography>
                )}
            </Box>

            {/* Pagination */}

            {totalItems > 0 && (
                <Box mt={2} display="flex" justifyContent="center" alignItems="center">
                    <Pagination
                        count={totalPages > 0 ? totalPages : 1}
                        page={page > totalPages ? totalPages : page}
                        onChange={(event, value) => setPage(value)}
                        color="primary"
                        showFirstButton
                        showLastButton
                        disabled={totalPages === 0}
                        siblingCount={0}
                        boundaryCount={1}
                        sx={{
                            '& .MuiPaginationItem-root': {
                                height: 30,
                                minWidth: 30,
                                fontSize: '1rem',
                                // marginTop: '10px'
                                margin: "15px"
                            }
                        }}
                    />
                </Box>
            )}
        </Box>

         <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
        </>
    );
};

export default DisplayService;
